import cls from "@fvilers/cls";
import { ComponentPropsWithRef } from "react";
import styles from "./Fieldset.module.css";

export function Fieldset({
  className,
  ...props
}: ComponentPropsWithRef<"fieldset">) {
  return <fieldset className={cls(styles.Fieldset, className)} {...props} />;
}

export function FieldsetLegend({
  className,
  ...props
}: ComponentPropsWithRef<"legend">) {
  return (
    <legend className={cls(styles.FieldsetLegend, className)} {...props} />
  );
}
